// extracted by mini-css-extract-plugin
export default {"widget-form":"_1EmCwdTH_R7hvWW-YTPZde","widget-form-row":"_2DNStQAOoVt_bI09abBtcA","widget-form__field":"_21WWODIGj4nZVusOCKENMJ"};